import React from "react";

import { connect } from "react-redux";
import Button from "@material-ui/core/Button";

import Chip from "@material-ui/core/Chip";
import ZeeTable from "components/ZeeTable";

import Item from "./item";
import "./style.scss";
import { setBreadcrumbs } from "reducers/view";

const arrayToObject = (array) =>
  array.reduce((obj, item) => {
    obj[item.id] = item;
    return obj;
  }, {});

class Checkout extends React.Component {
  state = {
    items: {},
  };

  constructor() {
    super(...arguments);

    const selection = this.props.history.location.state.selection ?? [];

    const items = arrayToObject(
      selection.map((stockId) => ({
        ...this.props.stock.find((stock) => stock.id === stockId),
        rows: [],
      }))
    );

    this.state = {
      ...this.state,
      items,
    };

    this.props.setBreadcrumbs([
      { name: "Purchases", slug: "/purchases" },
      {
        name: "Create Multiple Purchase Orders",
        slug: "/purchases/checkout",
      },
    ]);
  }

  get classNames() {
    const classes = ["checkout"];

    return classes.join(" ");
  }

  get itemsArr() {
    return Object.keys(this.state.items).map((id) => this.items[id]);
  }

  get items() {
    return this.state.items;
  }

  onUpdate(item) {
    const quantity =
      item?.rows.reduce((agg, item) => parseFloat(item.quantity) + agg, 0) ?? 0;

    this.setState({
      items: {
        ...this.items,
        [item.id]: {
          ...this.items[item.id],
          ...item,
          quantity,
        },
      },
    });

    return true;
  }

  onCreatePurchaseOrders() {
    const items = Object.values(this.items).reduce(
      (agg, item) =>
        item.quantity && item.quantity > 0 ? [...agg, item] : agg,
      []
    );

    const { history } = this.props;
    history.push({
      pathname: `/purchases/create`,
      state: {
        items,
      },
    });
  }

  render() {
    return (
      <div className={this.classNames}>
        <div className="wrapper">
          {this.itemsArr.map((item) => (
            <Item item={item} onUpdate={(item) => this.onUpdate(item)} />
          ))}
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={() => this.onCreatePurchaseOrders()}
        >
          Create Purchase Orders
        </Button>
      </div>
    );
  }
}
export default connect(
  (state) => {
    return {
      order: state.order.all,
      orderItem: state.order.item.all,
      product: state.product.all,
      productStock: state.product.stock.all,
      productGroup: state.product.group.all,
      stock: state.stock.all,
      stockSupplier: state.stock.supplier.all,
      stockLedger: state.stock.ledger.all,
      supplier: state.supplier.all,
    };
  },
  { setBreadcrumbs }
)(Checkout);
